import { useTranslation } from "react-i18next"

import { Checkbox } from "@/components/ui/checkbox"
import { Label } from "@/components/ui/label"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"

interface ToolConfig {
  id: string
  translationKey: string
  descriptionKey: string
}

interface AgentToolItemProps {
  tool: ToolConfig
  nodeId: string
  isEnabled: boolean
  onToggle: (toolId: string, checked: boolean) => void
  configComponent?: React.ReactNode
}

export function AgentToolItem({
  tool,
  nodeId,
  isEnabled,
  onToggle,
  configComponent,
}: AgentToolItemProps) {
  const { t } = useTranslation(undefined, { keyPrefix: "workflowLanding.agentNode" })

  return (
    <div className="flex items-center gap-2">
      <Checkbox
        checked={isEnabled}
        className="nodrag"
        id={`${nodeId}-${tool.id}`}
        onCheckedChange={(checked) => onToggle(tool.id, checked as boolean)}
      />
      <Tooltip>
        <TooltipTrigger asChild>
          <Label
            className="flex-1 cursor-help text-xs font-normal"
            htmlFor={`${nodeId}-${tool.id}`}
          >
            {t(`tools.${tool.translationKey}`)}
          </Label>
        </TooltipTrigger>
        <TooltipContent className="max-w-[250px]" side="right">
          <p className="text-xs">{t(tool.descriptionKey)}</p>
        </TooltipContent>
      </Tooltip>
      {configComponent}
    </div>
  )
}
